import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosBuzzOne } from '../../../../axios';
import { moduleName } from '../../module';
import { getAllSchool, postStatusFeaturedSchool } from '../../utils/apiRoutes';

export const postStatusFeaturedSchoolAsync = createAsyncThunk(
  `${moduleName}/postStatusFeaturedSchoolAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const { bodyData } = payload;
      const response = await axiosBuzzOne({
        method: 'POST',
        url: postStatusFeaturedSchool(),
        data: bodyData,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllSchoolAsync = createAsyncThunk(
  `${moduleName}/getAllSchoolAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: getAllSchool(),
      params: { ...params },
    });
    const data = response.data;
    return data;
  }
);

const FeaturedSchoolSlice = createSlice({
  name: `${moduleName}/UserKycApproval`,
  initialState: {
    schools: null,
    featuredStatus: null,
  },
  reducers: {},
  extraReducers: {
    [postStatusFeaturedSchoolAsync.pending]: (state) => {
      state.loading = true;
    },
    [postStatusFeaturedSchoolAsync.fulfilled]: (state) => {
      state.loading = false;
    },
    [postStatusFeaturedSchoolAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getAllSchoolAsync.pending]: (state) => {
      state.loading = true;
    },
    [getAllSchoolAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.schools = action.payload;
    },
    [getAllSchoolAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export default FeaturedSchoolSlice.reducer;
